/* Taken from Bootstrap 4 responsive breakpoints:
 * https://getbootstrap.com/docs/4.1/layout/overview/#responsive-breakpoints
 */
export const XXL = 1400;
export const XL = 1200;
export const LG = 992;
export const MD = 768;
export const SMD = 600;
export const SM = 480;